// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"footer-wrapper--R4ofL","footerWrapper":"footer-wrapper--R4ofL","text":"text--MRym0","logo-wrapper":"logo-wrapper--_e0XK","logoWrapper":"logo-wrapper--_e0XK"};